<template>
  <div class="meituanHome">
    <van-form class="container" @submit="onSubmit" validate-first>
      <van-field
        v-model="form.receiptCode"
        type="number"
        clearable
        center
        :left-icon="require('@/assets/img/meituan/pwd.jpg')"
        placeholder="团购券券码信息"
        :rules="[{ required: true, message: '请填写团购券券码信息' }]"
      />
      <van-field
        v-model="form.mobile"
        type="number"
        clearable
        center
        :left-icon="require('@/assets/img/meituan/phone.png')"
        placeholder="手机号码"
        :rules="[
          { required: true, message: '请填写手机号码' },
          { pattern: /^1[3456789]\d{9}$/, message: '请填写正确的手机号码' }
        ]"
      />
      <van-field
        v-model="form.verifyCode"
        center
        clearable
        :left-icon="require('@/assets/img/meituan/icon_pad.png')"
        placeholder="短信验证码"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
      >
        <template #button>
          <van-button
            size="small"
            color="#FAC530"
            loading-text="发送中..."
            :loading="yzmLoading"
            v-if="!timer"
            @click.stop="getCodeMeds"
            native-type="button"
          >
            发送验证码
          </van-button>
          <van-count-down v-else :time="timer" @finish="timer = 0" />
        </template>
      </van-field>
      <van-button
        block
        color="#FAC530"
        loading-text="加载中..."
        :loading="loading"
        class="redeemBtn"
        native-type="submit"
      >
        立即兑换
      </van-button>
      <van-button
        block
        native-type="button"
        class="viewCouponBtn"
        @click="jumpDetail()"
      >
        查看我的券包
      </van-button>
      <div class="tips">
        特别说明：
        <span style="color: red;"
          >您买的团购券一经兑换，概不退换，请慎重兑换，谨防刷单诈骗！</span
        ><br />
        如有疑问请拨打客服电话400-662-7299（服务时间9:00-21:00）
      </div>
    </van-form>
  </div>
</template>

<script>
import { verifyForH5, sendVerifyCodeForH5 } from '@/api/mtH5'
export default {
  name: 'mtH5Index',
  data() {
    return {
      form: {
        mobile: '',
        receiptCode: '',
        verifyCode: ''
      },
      loading: false,
      yzmLoading: false,
      timer: 0
    }
  },
  created() {},
  methods: {
    async getCodeMeds() {
      if (!this.form.mobile && !this.form.receiptCode) {
        this.$toast.fail('请填写券码信息&手机号')
        return
      }
      this.yzmLoading = true
      const { code } = await sendVerifyCodeForH5({
        bizType: 2, // 业务类型，1-登录，2-验券
        mobile: this.form.mobile,
        receiptCode: this.form.receiptCode
      }).finally(() => {
        this.yzmLoading = false
      })
      if (code === 0) {
        this.timer = 60000
      }
    },
    async onSubmit() {
      try {
        await this.$dialog.confirm({
          title: '',
          message:
            '请确认为<span style="color: #ee0a24">个人真实消费需求后进行兑换</span>，无他人引导或屏幕共享，<span style="color: #ee0a24">一经兑换，概不退换</span>。切不可将卡号、卡密转交给其他人，<span style="color: #ee0a24">谨防诈骗！</span>'
        })
        this.loading = true
        const { code, data } = await verifyForH5(this.form)
        if (code === 0) {
          sessionStorage.setItem('mtH5Token', data?.token)
          this.$router.push({
            name: 'mtH5Detail',
            query: {
              mobile: this.form.mobile,
              receiptCode: this.form.receiptCode
            }
          })
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async jumpDetail() {
      // await this.$dialog.confirm({
      //   title: '',
      //   message:
      //     '请勿在与他人共享屏幕时打开查看卡密信息，请妥善保管信息，切不可将卡号、卡密交给其他人，谨防诈骗！'
      // })
      this.$router.push({
        name: 'mtH5Login'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.meituanHome {
  min-height: 100vh;
  background: #ffea8e url(../../assets/img/meituan/indexBg.jpg) top center
    no-repeat;
  background-size: 100% auto;
  .container {
    position: fixed;
    bottom: 8%;
    width: 90%;
    left: 5%;
    padding: 49px 23px 75px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 15px;
    .formInput {
      background: #f5f7fd;
      border-radius: 10px;
      &::after {
        border-bottom: none;
      }
    }
    .redeemBtn {
      color: #000;
      margin: 30px 0 21px;
      border-radius: 10px;
      font-size: 16px;
      color: #000000;
    }
    .viewCouponBtn {
      border-radius: 10px;
      font-size: 16px;
      color: #000000;
    }
    .tips {
      font-size: 12px;
      color: #323233;
      margin: 20px auto 0;
    }
  }
}
</style>
